/* global axios */

import ApiClient from './ApiClient';

class CannedResponseAsset extends ApiClient {
  constructor() {
    super('canned_response_assets', { accountScoped: true });
  }

  create(formData) {
    return axios.post(this.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new CannedResponseAsset();
